import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { WHATSAPP_NUMBER } from "@/data/site";

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export default function Layout({ children }) {
  const [showMobileWhatsApp, setShowMobileWhatsApp] = useState(false);

  useEffect(() => {
    const updateVisibility = () => setShowMobileWhatsApp(window.scrollY > 140);
    updateVisibility();
    window.addEventListener("scroll", updateVisibility, { passive: true });
    return () => window.removeEventListener("scroll", updateVisibility);
  }, []);

  return (
    <div className="min-h-screen bg-ivory">
      <ScrollTop />
      <Header />
      <main>{children}</main>
      <Footer />
      <a
        data-testid="whatsapp-float-button"
        href={`https://wa.me/${WHATSAPP_NUMBER}?text=Hello%20Travel%20Bug%20India%2C%20I'd%20like%20to%20enquire.`}
        target="_blank"
        rel="noopener noreferrer"
        className={`fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-50 w-12 h-12 sm:w-auto sm:h-auto grid sm:flex place-items-center sm:gap-2 rounded-full bg-teal/90 backdrop-blur-md text-ivory sm:pl-4 sm:pr-5 sm:py-3.5 shadow-lg shadow-teal/20 transition-all duration-300 hover:-translate-y-1 ${
          showMobileWhatsApp
            ? "opacity-100 translate-y-0"
            : "opacity-0 pointer-events-none translate-y-2 sm:opacity-100 sm:pointer-events-auto sm:translate-y-0"
        }`}
      >
        <MessageCircle size={20} />
        <span className="text-sm font-semibold hidden sm:inline">Enquire</span>
      </a>
    </div>
  );
}
